module.exports = __webpack_public_path__ + "media/taipei/Beitou-c26bde09.jpg";